import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconChevronDoubleLeft';
/** Renders an SVG icon. */
const SvgChevronDoubleLeft = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        d="M15.796 9.796a1.126 1.126 0 0 0-1.592-1.592l-7 7c-.44.44-.44 1.152 0 1.592l7 7a1.126 1.126 0 0 0 1.592-1.592L9.592 16z"
      />
      <path
        fill="currentColor"
        d="M23.796 9.796a1.126 1.126 0 0 0-1.592-1.592l-7 7c-.44.44-.44 1.152 0 1.592l7 7a1.126 1.126 0 0 0 1.592-1.592L17.592 16z"
      />
    </svg>
  );
};
SvgChevronDoubleLeft.displayName = displayName;
export default SvgChevronDoubleLeft;
